import { FavouriteCondition } from 'app/types-shared';

/**
 * Groups conditions that represent the same filter (e.g. number or date ranges)
 *
 * @param conditions List of conditions from favourite definition
 */
export const groupConditions = (conditions: FavouriteCondition[]) => !!conditions
  ? conditions.reduce((result, condition, index) => {

    // Check if list already contatins condidtion to avoid duplicates
    if (result.some(groupedConditions => groupedConditions.some(c => c === condition))) {
      return result;
    }

    // No matching condition found
    return [
      ...result,
      [condition]
    ];
  }, [] as FavouriteCondition[][])
  : [];
